import React, { useState, useEffect } from 'react';
import InvoiceForm from './InvoiceForm';
import InvoiceHistory from './InvoiceHistory';
import ManageClients from './ManageClients';
import TemplateGallery from './TemplateGallery';
import DashboardStats from './DashboardStats';
import AuditLogs from './AuditLogs';
import { PlusCircle, History, Users, Layers, LayoutDashboard, BarChart3, Activity } from 'lucide-react';

const Dashboard = ({ user }) => {
  const userRole = user?.role || user?.Role;
  const [activeTab, setActiveTab] = useState('stats'); // Default to Stats for better experience
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    fetch('/api/invoice/templates')
      .then(res => res.json())
      .then(data => setTemplates(data))
      .catch(err => console.error("Could not load templates", err));
  }, []);

  const TabButton = ({ id, icon: Icon, label, color }) => (
    <button 
      onClick={() => setActiveTab(id)} 
      className={`tab-button ${activeTab === id ? 'active' : ''}`}
      style={activeTab === id ? { '--primary': color } : {}}
    >
      <Icon size={18} style={{ marginRight: '0.6rem' }} /> {label}
    </button>
  );

  return (
    <div>
      <div className="no-print" style={{ marginBottom: '2.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ background: 'var(--primary)', color: 'white', padding: '0.5rem', borderRadius: '10px' }}>
                <LayoutDashboard size={24} />
            </div>
            <div>
                <h2 style={{ fontSize: '1.5rem', margin: 0 }}>System Control</h2>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>Manage your professional invoicing ecosystem</p>
            </div>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <TabButton id="stats" icon={BarChart3} label="Dashboard Analytics" color="#4F46E5" />
            
            {userRole !== 'SuperAdmin' && (
                <TabButton id="new" icon={PlusCircle} label="Create New Invoice" color="#10B981" />
            )}
            
            <TabButton id="history" icon={History} label="Invoice History" color="#3B82F6" />

            {userRole === 'SuperAdmin' && (
                <>
                    <TabButton id="clients" icon={Users} label="Manage Clients" color="#8B5CF6" />
                    <TabButton id="templates" icon={Layers} label="Template Gallery" color="#F59E0B" />
                    <TabButton id="audit" icon={Activity} label="Audit Logs" color="#64748b" />
                </>
            )}
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'stats' && <DashboardStats user={user} />}
        {activeTab === 'new' && userRole !== 'SuperAdmin' && <InvoiceForm user={user} templates={templates} onCreated={() => setActiveTab('history')} />}
        {activeTab === 'history' && <InvoiceHistory user={user} />}
        {activeTab === 'clients' && userRole === 'SuperAdmin' && <ManageClients templates={templates} />}
        {activeTab === 'templates' && userRole === 'SuperAdmin' && <TemplateGallery />}
        {activeTab === 'audit' && userRole === 'SuperAdmin' && <AuditLogs />}
      </div>
    </div>
  );
};

export default Dashboard;
